module.exports = __webpack_public_path__ + "static/img/brees-2018-jump.24b5f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-jump.jpg
// module id = 05R1
// module chunks = 1